import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type {
  NamedLocationAclMembers,
  NamedRoomAclMembers,
  NamedUserGroupAclMembers,
} from '../../types/acl-named.types';

@Component({
  selector: 'era-acl-member-list',
  templateUrl: './acl-member-list.component.html',
  styleUrls: ['./acl-member-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
})
export class AclMemberListComponent {
  readonly members = input<NamedUserGroupAclMembers[] | NamedLocationAclMembers[] | NamedRoomAclMembers[] | undefined>(
    undefined
  );

  readonly header = input('Users');
  readonly routePrefix = input('');
}
